<template>
  <!-- 线下诊断--  诊断编辑 -->
  <el-dialog
    id="bb"
    :center="true"
    :close-on-click-modal="false"
    title="线下诊断报告"
    :visible.sync="showEdit"
    @close="closeEditDialog"
    width="55%"
  >
    <el-form
      :rules="rules"
      ref="diagnosisOff"
      :model="diagnosisOff"
      label-width="100px"
    >
      <el-form-item label="学生姓名">
        <el-input
          v-model="diagnosisOff.studentName"
          style="width: 100%"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="学生年级" style="width: 100%">
        <el-cascader
          style="width: 100%"
          v-model="diagnosisOff.grade"
          :options="diagnosisOff.gradeList"
          :props="props"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="学生性别">
        <el-radio-group v-model="diagnosisOff.sex">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="家庭住址">
        <el-input v-model="diagnosisOff.address" style="width: 100%"></el-input>
      </el-form-item>
      <el-form-item label="家长电话">
        <el-input
          v-model="diagnosisOff.parentPhoneNumber"
          @input="phoneChange"
          style="width: 100%"
        ></el-input>
      </el-form-item>
      <el-form-item label="课程类别">
        <el-cascader
          style="width: 100%"
          v-model="diagnosisOff.courseCategoryIds"
          :options="categoryList"
          :props="propsCategory"
        ></el-cascader>
      </el-form-item>
      <el-form-item label="查看线上诊断">
        <el-button type="primary" @click="toOnline" size="small"
          >查看线上诊断</el-button
        >
      </el-form-item>
      <el-form-item label="线下诊断老师">
        <!-- <el-select style="width: 100%;" v-model="diagnosisOff.teacherId" placeholder="请线下选择老师">
          <el-option v-for="item in teachers" :key="item.id" :label="item.realname" :value="item.id"></el-option>
        </el-select> -->
        <el-select
          multiple
          v-model="diagnosisOff.teacherIdArr"
          clearable
          style="width: 100%"
          placeholder="请选择老师"
        >
          <el-option
            v-for="item in teachers"
            :key="item.id"
            :label="item.realname"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线下诊断时间">
        <el-date-picker
          v-model="diagnosisOff.startTimeDay"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择诊断日期"
        >
        </el-date-picker>
        <mz-time-select
          style="width: 190px; display: inline-block"
          :childPlaceholder="'开始时间'"
          :timePeriod="'start'"
          @clean="clean"
          @startTimeSelect="startTimeSelect"
          v-model="diagnosisOff.startTimeHour"
          :valueTime="diagnosisOff.startTimeHour"
        ></mz-time-select>
        <span style="margin-left: 5px"></span>
        <mz-time-select
          style="width: 190px; display: inline-block"
          :childPlaceholder="'结束时间'"
          :timePeriod="'end'"
          @clean="clean"
          @startTimeSelect="startTimeSelect"
          v-model="diagnosisOff.endTimeHour"
          :valueTime="diagnosisOff.endTimeHour"
        ></mz-time-select>
        <!-- <el-time-select
          style="width: 180px;"
          placeholder="起始时间"
          v-model="diagnosisOff.startTimeHour"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select>
        <el-time-select
          style="width: 180px;"
          placeholder="结束时间"
          v-model="diagnosisOff.endTimeHour"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
        >
        </el-time-select> -->
      </el-form-item>
      <!-- <el-form-item label="线下诊断费用">
        <el-input v-model="diagnosisOff.diagnosisPay" placeholder="请输入线下诊断费用"></el-input>
      </el-form-item> -->
      <!-- 1待诊断 2已诊断     下拉框一会写-->
      <el-form-item label="线下诊断状态">
        <el-select
          style="width: 100%"
          v-model="diagnosisOff.stautsId"
          placeholder="请选择线上诊断状态"
        >
          <el-option
            v-for="item in offlineStatus"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <!-- 1待沟通 2沟通 3已收款    下拉框一会写-->
      <el-form-item label="沟通状态">
        <el-select
          style="width: 100%"
          v-model="diagnosisOff.talkId"
          placeholder="请选择沟通状态"
        >
          <el-option
            v-for="item in talkStatus"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="线下诊断模板">
        <el-select
          style="width: 100%"
          v-model="diagnosisOff.templateId"
          placeholder="请选择线下诊断模板"
          @change="getTemplate(diagnosisOff.templateId)"
        >
          <el-option
            v-for="item in Templates"
            :key="item.templateId"
            :label="item.templateName"
            :value="item.templateId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="diagnosisOff.diagnosisType === '1'"
        :label="diagnosisOff.tipsTitle"
      >
        <el-row>
          <!-- <el-upload
            ref="upload"
            style="display: inline-block"
            :action="imageUrl2"
            :on-success="handleSuccess"
          >
            <el-button type="text" style="margin-right: 50px">上传</el-button>
          </el-upload> -->

          
          <el-upload
              ref="upload"
              action="#"
              :beforeUpload="beforeUpload"
              :http-request="handleUpload"
              :on-remove="handleRemove"
              :file-list="fileLists"
              :auto-upload="true"
              drag
              :limit="1">
              <!-- <img v-if="screenshot" :src="screenshot" style="width: 100%;height: 100%;" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
              <el-button type="text" style="margin-right: 50px">上传</el-button>
            </el-upload>



          <a :href="diagnosisOff.diagnosisUrl" target="_blank" v-if="uploadFlag && diagnosisOff.diagnosisUrl"
            >下载</a
          >
        </el-row>
      </el-form-item>
      <el-form-item style="margin-top: -20px" label="线下诊断信息">
        <el-form-item style="margin-top: 10px">
          <el-button
            icon="el-icon-circle-plus-outline"
            @click="addInput"
          ></el-button>
          <el-button
            icon="el-icon-remove-outline"
            @click="removeItem"
          ></el-button>
        </el-form-item>
      </el-form-item>
      <el-form-item style="margin-left: -99px; margin-top: -8px">
        <el-form-item
          v-for="(item, index) in diagnosisOff.diagnosisDetailArr"
          :key="index"
        >
          <el-form-item :label="'问题' + (index + 1)">
            <el-input
              :disabled="true"
              v-model="item.question"
              size="small"
              style="width: 80%"
              placeholder="请输入问题"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item :label="'回答' + (index + 1)">
            <el-input
              type="textarea"
              :rows="2"
              v-model="item.tips"
              size="small"
              style="width: 80%"
              :placeholder="item.answer"
            ></el-input>
          </el-form-item>
        </el-form-item>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          v-model="diagnosisOff.node"
          type="textarea"
          :rows="2"
          placeholder="请输入内容"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="closeEditDialog">取消</el-button>
      <el-button size="small" type="primary" @click="saveEditForm"
        >保存</el-button
      >
    </span>
    <diagnosis-view ref="diagnosisView"></diagnosis-view>
  </el-dialog>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../../config/api";
import DiagnosisView from "./DiagnosisView.vue";
import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
export default {
  components: { DiagnosisView },
  data() {
    return {
      uploadFlag: false,
      imageUrl2: `${apiBaseUrl}/customerinformation/importFile`,
      Templates: [], //模板集合
      teachers: [], //老师集合
      categoryList: [], //课程集合
      offlineStatus: [
        {
          id: 1,
          label: "待诊断",
        },
        {
          id: 2,
          label: "已诊断",
        },
      ],
      talkStatus: [
        {
          id: 1,
          label: "待沟通",
        },
        {
          id: 2,
          label: "已沟通",
        },
        {
          id: 3,
          label: "已收款",
        },
      ],
      rules: {},
      showEdit: false,
      propsCategory: {
        label: "categoryName",
        children: "children",
        value: "id",
      },
      props: {
        label: "gradeName",
        children: "children",
        value: "id",
      },
      diagnosisOff: {
        tipsTitle: "",
        diagnosisId: "",
        templateId: "",
        teacherId: "",
        teacherIdArr: [],
        startTimeDay: "",
        startTimeHour: "",
        endTimeHour: "",
        diagnosisTimeArr: [],
        onlineTime: [],
        offlineTime: [],
        customerId: "",
        diagnosisPay: "",
        diagnosisUrl: "",
        diagnosisStatus: "",
        diagnosisType: "",
        categoryId: "",
        studentId: "",
        studentName: "", //学生姓名
        gradeList: [], //年级
        grade: [], //年级id
        sex: "", //性别
        address: "", //地址
        parentPhoneNumber: "", //家长电话
        node: "", //备注
        courseCategoryIds: [], //课程类别
        stautsId: 1, //诊断状态
        talkId: 1, //沟通状态
        diagnosisDetailArr: [
          {
            question: "",
            answer: "",
            tips: "",
          },
        ],
      },
      template: {
        templateStatus: 1,
      },
      fileLists:[],
    };
  },
  computed: {},
  watch: {},
  methods: {
    phoneChange() {
      this.diagnosisOff.parentPhoneNumber = this.diagnosisOff.parentPhoneNumber.replace(/[^\d]/g, "");
      if (this.diagnosisOff.parentPhoneNumber.length > 11) {
        this.diagnosisOff.parentPhoneNumber = this.diagnosisOff.parentPhoneNumber.substr(0, 11);
      }
      let reg = /^1[3456789]\d{9}$/;
      if (this.diagnosisOff.parentPhoneNumber.length >= 11 && !reg.test(this.diagnosisOff.parentPhoneNumber)) {
         this.$notify({
          title: '警告',
          message: '请输入正确的手机号码格式',
          type: 'warning'
        });
      }
    },
    clean(val) {
      if (val == "start") {
        this.diagnosisOff.startTimeHour = "";
      } else {
        this.diagnosisOff.endTimeHour = "";
      }
    },
    startTimeSelect(val, row) {
      // this.diagnosisOff.startTimeHour = val
      if (val == "start") {
        this.diagnosisOff.startTimeHour = row;
      } else {
        this.diagnosisOff.endTimeHour = row;
      }
    },
    endTimeSelect(val) {
      this.order.offEndTime = val;
      console.log(val);
    },
    saveEditForm() {
      console.log(
        this.diagnosisOff,
        "diagnosisOffdiagnosisOffdiagnosisOffdiagnosisOffdiagnosisOff"
      );
      //点击保存的时候把日期时间写在同一个数组中
      this.diagnosisOff.offlineTime = [
        this.diagnosisOff.startTimeDay,
        this.diagnosisOff.startTimeHour,
        this.diagnosisOff.endTimeHour,
      ];
      this.diagnosisOff.onlineTime = [];
      // if (this.diagnosisOff.diagnosisDetailArr.length <= 0 && this.diagnosisOff.diagnosisUrl === '') {
      //   this.$message({
      //     message: '请上传文件或者输入问题',
      //     type: 'error'
      //   })
      //   return
      // }
      // this.diagnosisOff.diagnosisTimeArr.push(this.diagnosisOff.startTimeDay, this.diagnosisOff.startTimeHour)
      if (this.diagnosisOff.diagnosisId === "") {
        this.diagnosisOff.diagnosisStatus = 2;
        axios
          .post(`${apiBaseUrl}/diagnosis/add`, this.diagnosisOff,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code === 200) {
              this.fileLists = []
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.showEdit = false;
              this.$emit("refreshOrder");
            } else {
              this.$message({
                message: res.data.message,
                type: "error",
              });
            }
          });
      } else {
        this.diagnosisOff.diagnosisStatus = 2;
        axios
          .put(`${apiBaseUrl}/diagnosis/update`, this.diagnosisOff,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
          .then((res) => {
            if (res.data.code === 200) {
              this.fileLists = []
              this.$message({
                message: "保存成功",
                type: "success",
              });
              this.$emit("refreshOrder");
              this.showEdit = false;
            } else {
              this.$message({
                message: "保存失败",
                type: "error",
              });
            }
          });
      }
    },
    handleSuccess(response, file, fileList) {
      this.diagnosisOff.diagnosisUrl =
        "https://www.mzkt.top/img/" + response.data.url;
      this.uploadFlag = true;
      this.screenshot = URL.createObjectURL(file.raw);
      // 处理上传成功的回调逻辑
    },
    //添加输入框
    addInput() {
      if (this.diagnosisOff.diagnosisDetailArr == null) {
        this.diagnosisOff.diagnosisDetailArr = [
          {
            question: "",
            tips: "",
            answer: "",
          },
        ];
      } else {
        if (this.diagnosisOff.diagnosisDetailArr.length >= 1) {
          this.diagnosisOff.diagnosisDetailArr.push({
            question: "",
            answer: "",
            tips: "",
          });
        } else {
          this.diagnosisOff.diagnosisDetailArr = [
            {
              question: "",
              tips: "",
              answer: "",
            },
          ];
        }
      }
    },

    beforeUpload(file) {
      // 在上传之前对文件大小进行检查
      // 可以根据需求自定义文件大小限制，或者设置为无限制
      // 例如：限制文件大小为10MB
      const maxSize = 100 * 1024 * 1024; // 100MB
      if (file.size > maxSize) {
        this.$message.error("文件大小超过限制");
        return false; // 阻止文件上传
      }
    },

    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },

    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {
        console.log(res);
        this.uploadFlag = true;
        this.diagnosisOff.diagnosisUrl = res.url
        this.screenshot = res.url
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {
          console.log(res);
        });
      });
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;
      this.diagnosisOff.diagnosisUrl = ""
    },

    //减少输入框
    removeItem() {
      if (this.diagnosisOff.diagnosisDetailArr.length > 1) {
        this.diagnosisOff.diagnosisDetailArr.pop();
      } else {
        this.diagnosisOff.diagnosisDetailArr.splice(
          0,
          this.diagnosisOff.diagnosisDetailArr.length
        );
      }
    },
    //获取学生年级
    getGrade() {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          if (res.data.data.length > 0) {
            this.diagnosisOff.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    //获取课程类别
    getCategoryList() {
      axios
        .get(`${apiBaseUrl}/category/list`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.categoryList = res.data.data;
        })
        .catch((error) => {
          this.$message({
            message: "获取课程列表失败",
            type: "error",
          });
        });
    },
    //初始化
    init(id) {
      this.diagnosisOff.customerId = id;
      this.diagnosisOff.diagnosisStatus = 2;
      axios
        .post(`${apiBaseUrl}/diagnosis/getOne`, this.diagnosisOff,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.getCustomer(this.diagnosisOff.customerId);
          if (res.data.code === 200 && res.data.data !== null) {
            this.diagnosisOff.stautsId = res.data.data.stautsId; //诊断状态
            this.diagnosisOff.talkId = res.data.data.talkId; //沟通状态
            this.diagnosisOff.node = res.data.data.node; //备注
            this.diagnosisOff.diagnosisId = res.data.data.diagnosisId;
            this.diagnosisOff.customerId = res.data.data.customerId;
            this.diagnosisOff.tipsTitle = res.data.data.tipsTitle;
            this.diagnosisOff.templateId = res.data.data.templateId;
            // this.diagnosisOff.teacherId = res.data.data.teacherId
            this.diagnosisOff.startTimeDay = JSON.parse(
              res.data.data.diagnosisTime
            )[0];
            this.diagnosisOff.startTimeHour = JSON.parse(
              res.data.data.diagnosisTime
            )[1];
            this.diagnosisOff.diagnosisUrl = res.data.data.diagnosisUrl;
            this.diagnosisOff.diagnosisPay = res.data.data.diagnosisPay;
            this.diagnosisOff.diagnosisType = res.data.data.diagnosisType + "";
            this.diagnosisOff.diagnosisStatus = res.data.data.diagnosisStatus;
            this.diagnosisOff.diagnosisDetailArr = JSON.parse(
              res.data.data.diagnosisDetail
            );
            if (
              res.data.data.diagnosisUrl !== null &&
              res.data.data.diagnosisUrl !== ""
            ) {
              this.uploadFlag = true;
              this.diagnosis.diagnosisUrl = res.data.data.diagnosisUrl;
            }
            this.showEdit = true;
          } else {
            this.diagnosisOff.stautsId = 1;
            this.diagnosisOff.talkId = 1;
            this.diagnosisOff.diagnosisId = "";
            this.diagnosisOff.templateId = "";
            this.diagnosisOff.teacherId = "";
            this.diagnosisOff.startTimeDay = "";
            this.diagnosisOff.startTimeHour = "";
            this.diagnosisOff.diagnosisUrl = "";
            this.diagnosisOff.diagnosisPay = "";
            this.diagnosisOff.diagnosisType = "";
            this.diagnosisOff.diagnosisStatus = "";
            this.diagnosisOff.diagnosisDetailArr = [
              {
                question: "",
                tips: "",
                answer: "",
              },
            ];
            this.showEdit = true;
          }
        });
    },
    //查看线上诊断
    toOnline() {
      this.$nextTick(() => {
        this.$refs.diagnosisView.init(this.diagnosisOff.customerId);
      });
    },
    closeEditDialog() {
      this.diagnosisOff.node = "";
      this.diagnosisOff.studentId = "";
      this.fileLists = []
      this.showEdit = false;
    },
    getTeachers() {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((res) => {
          this.teachers = res.data.data;
        })
        .catch((error) => {
          this.$message({
            message: "获取老师列表失败",
            type: "error",
          });
        });
    },
    getTemplates() {
      axios.post(`${apiBaseUrl}/template/page`, this.template,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        if (res.data.code === 200) {
          this.Templates = res.data.data;
        } else {
          this.$message({
            message: res.data.message,
            type: "error",
          });
        }
      });
    },
    //单个查询
    getCustomer(id) {
      axios
        .get(`${apiBaseUrl}/customerinformation/getOne/${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then((response) => {
          this.diagnosisOff.studentId = response.data.data.list.studentId;
          this.diagnosisOff.address = response.data.data.list.address; //地址
          this.diagnosisOff.studentName =
            response.data.data.list.customerStudent;
          this.diagnosisOff.parentPhoneNumber =
            response.data.data.list.parentPhoneNumber;
          this.diagnosisOff.sex = response.data.data.list.sex;
          this.diagnosisOff.grade = response.data.data.list.gradeIdArr2;
          this.diagnosisOff.courseCategoryIds =
            response.data.data.list.categoryIdArr2; //课程
          // this.diagnosisOff.diagnosisPay = response.data.data.list.customerAllpaymoney; // 赋值
          // this.diagnosisOff.teacherId = response.data.data.list.teacherIdOffline; // 赋值
          if (response.data.code == 200) {
            if (
              response.data.data.list.teacherIdOffline == null &&
              response.data.data.list.teacherIdOfflineArr == null
            ) {
              this.diagnosisOff.teacherIdArr = [];
            } else {
              if (response.data.data.list.teacherIdOfflineArr == []) {
                this.diagnosisOff.teacherIdArr = [];
              } else {
                if (response.data.data.list.teacherIdOfflineArr) {
                  this.diagnosisOff.teacherIdArr = JSON.parse(
                    response.data.data.list.teacherIdOfflineArr
                  );
                } else {
                  this.diagnosisOff.teacherIdArr = [
                    response.data.data.list.teacherIdOffline,
                  ];
                }
              }
            }
            this.diagnosisOff.teacherId = null;
          }

          this.diagnosisOff.startTimeDay = JSON.parse(
            response.data.data.list.offlineTime
          )[0];
          this.diagnosisOff.startTimeHour = JSON.parse(
            response.data.data.list.offlineTime
          )[1];
          this.diagnosisOff.endTimeHour = JSON.parse(
            response.data.data.list.offlineTime
          )[2];
          this.diagnosisOff.categoryId =
            response.data.data.list.categoryIdArr2[1];
          // this.diagnosisOff.studentId = response.data.data.list.studentId;
        })
        .catch((error) => {
          console.error(error);
        });
      this.showEdit = true;
    },
    getTemplate(id) {
      axios.get(`${apiBaseUrl}/template/getById/${id}`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }).then((res) => {
        this.diagnosisOff.diagnosisDetailArr = JSON.parse(
          res.data.data.templateSet
        );
        this.diagnosisOff.diagnosisType = res.data.data.templateType + "";
        this.diagnosisOff.tipsTitle = res.data.data.tipsTitle;
      });
    },
  },
  beforeCreate() {},

  created() {
    this.getTeachers();
    this.getTemplates();
    this.getGrade();
    this.getCategoryList();
  },

  beforeMount() {},

  mounted() {},

  beforeUpdate() {},

  updated() {},

  beforeDestroy() {},
  destroyed() {},

  activated() {},
};
</script>

<style scoped>
>>> .el-upload-dragger{
  width: 100px !important;
  height: 50px !important;
  padding-left: 30px;
}
/* 兼容移动端 */
@media screen and (max-width: 750px) {
  /* 兼容移动端 */
  #bb >>> .el-dialog {
    width: 83% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/manager/components/OffDiagnosisView.vue